import { LegacyTeamPage } from 'components/teamPageLegacy/containers/teamPage';
import { TeamPage } from 'components/teamPageNew';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

export const TeamView = (): JSX.Element => {
  const { legacyTeamOverview } = useFeatureFlag(['legacy-team-overview']);
  return legacyTeamOverview ? <LegacyTeamPage /> : <TeamPage />;
};
